<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 approvalTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="approval"
                        arrows >
                    <template slot="gofixTab:approval">
                        <div class="mb-3 mt-2"><gofix-button label="New Route" @click="openNewRouteModal" outline></gofix-button></div>
                        <approval-item v-for="(item, index) in contractApprovals" :key="index" :approvalItem="item" @reload-list="getContractApproval" @edit-template="editRouteModal"></approval-item>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true"
                 modal-class="default-modal approval-route-modal"
                 title="Add New Route"
                 hide-footer :centered="true"
                 v-model="modals.route.open">
            <b-form class="pb-20">
                <gofix-form-dropdown
                        label="Route Type"
                        :options="modals.route.routeType"
                        vLabel="reference_value_text"
                        :reduce="option => option.id"
                        v-model="modals.route.data.approval_process_id">
                </gofix-form-dropdown>
                <gofix-form-properties
                        label="Property"
                        :contract-id="$route.params.id"
                        showIconRequired
                        v-model="modals.route.data.property_id" required>
                </gofix-form-properties>
                <gofix-form-input-date
                    label="Effective Date" 
                    popoverDirection="top"
                    :min-date="new Date()"
                    :required="true"
                    :show-icon-required="true"
                    v-model="modals.route.data.effective_date">
                </gofix-form-input-date>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="newContractRoute" :loading="modals.route.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true"
                 modal-class="default-modal approval-route-modal"
                 title="Edit Route"
                 hide-footer :centered="true"
                 v-model="modals.routeEdit.open">
            <b-form class="pb-20">
                <gofix-form-input-date
                    label="Effective Date" 
                    popoverDirection="top"
                    :min-date="new Date()"
                    :required="true"
                    :show-icon-required="true"
                    v-model="modals.routeEdit.data.effective_date" >
                </gofix-form-input-date>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="editContractRoute" :loading="modals.routeEdit.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
    import tabData from '@/data/_tabs';
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';
    const ApprovalItem = () => import("./item")
    import moment from 'moment';
    export default {
        name: 'approval',
        components: {
            'approval-item' : ApprovalItem
        },
        data () {
            let filter = JSON.parse(JSON.stringify(filters['approval_route']));
            return {
                contract_tab:tabData.client_contract,
                approvals:{
                    tableConfig:{
                        name: 'contract-checklist',
                        controls:{
                            create: false,
                            delete: false
                        },
                        filter: filter,
                        page: 1,
                        limit: 100,
                        total: 0,
                        fields: [
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'checkbox-column text-center',
                                tdClass: 'checkbox-column text-center',
                                width: 50,
                                thStyle: "width:50px",
                            },
                            {
                                key: 'sequence',
                                label: 'Approval Level',
                                isActive: 1,
                                isFilter: true,
                                thStyle: "width:150px",
                                sorting: true,
                                with:150,
                                thClass: 'checkbox-column text-right',
                                tdClass: 'checkbox-column text-right',
                            },
                            {
                                key: 'finance_limit',
                                label: 'Finance Limit',
                                isActive: 1,
                                isFilter: true,
                                thStyle: "width:150px",
                                sorting: true,
                                with:150,
                                thClass: 'checkbox-column text-right',
                                tdClass: 'checkbox-column text-right',
                            },
                            {
                                key: 'role_name',
                                label: 'Role',
                                isActive: 1,
                                isFilter: true,
                                thStyle: "width:auto",
                                sorting: true,
                                with:null,
                            }
                        ],
                        sortColumn: "sequence",
                        sortDirection: "asc",
                    },
                    tableItems: [],
                },
                contractApprovals:[],
                modals:{
                    route:{
                        open:false,
                        loading:false,
                        data:{
                            contract_id: this.$route.params.id,
                            approval_process_id: null,
                            location: null,
                            property_id: null,
                            effective_date: null
                        },
                        routeType:[],
                        properties:[],
                    },
                    routeEdit:{
                        open:false,
                        loading:false,
                        data:{
                            id: null,
                            contract_id: this.$route.params.id,
                            approval_process_id: null,
                            property_id: null,
                            effective_date: null
                        },
                        routeType:[],
                        properties:[],
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            ClientContractID: function(val, old) {
                if (!val) {
                    return this.$router.push(`/v2/contract-client`)
                }
                
                if(old && val && old.id && val.id && old.id != val.id) {
                    this.modals.route.data.contract_id = val.id
                    this.getContractApproval();
                    this.getRouteType();
                    this.getPropertyBYRoute();
                }
            },
        },
        async created() {
            this.getContractApproval();
            this.getRouteType();
            this.getPropertyBYRoute();

        },
        methods:{
            /*-- SAVE ------------------*/
            newContractRoute(){
                if(!this.modals.route.data.approval_process_id){
                    return this.$alertNotification("Please select a route type", "danger");
                }
                if(!this.modals.route.data.property_id){
                    return this.$alertNotification("Please select a property", "danger");
                }
                if(!this.modals.route.data.effective_date){
                    return this.$alertNotification("Please select effective date", "danger");
                }

                //Save data
                if(this.modals.route.loading) return ;
                this.modals.route.loading = true;
                let request = Object.assign({}, this.modals.route.data);
                request.effective_date = moment(request.effective_date).format('YYYY-MM-DD');
                this.$store.dispatch("ApprovalTemplateController/saveItem", request)
                    .then(response => {
                        this.$alertNotification(this.$notificationV2('adding', 'approval_template'));
                        this.modals.route.loading = false;
                        this.modals.route.open = false;
                        this.getContractApproval();
                    })
                    .catch(error => {
                        this.modals.route.loading = false;
                        if(error.response.data && error.response.data.error && error.response.data.error.message && error.response.data.error.message.error) {
                            this.$alertNotification(error.response.data.error.message.error, 'danger');
                        }
                    });
            },

            /*-- GET ------------------*/
            getRouteType(){
                this.$store.dispatch("ReferenceController/getItems", {
                    limit:-1,
                    page:1,
                    filter: {
                        reference_type:"Approval Processes",
                    },
                }).then(response => {
                    this.modals.route.routeType = response.items;
                });
            },

            getPropertyBYRoute(){
                global.axios(`api/contracts/${this.$route.params.id}/tree-properties/0`, {
                    method: "GET",
                    data: {},
                    headers: {
                        Accept: "application/json",
                    }
                })
                    .then(result => {
                        this.modals.route.properties = result.data.data;
                    })
            },

            getContractApproval(){
                this.contractApprovals = [];
                let requestData = {
                    limit: -1,
                    page: 1,
                    filter: {
                        name_null : true,
                        contract_id : this.$route.params.id
                    }
                };
                this.$store.dispatch("ApprovalTemplateController/getItems", requestData)
                    .then(response => {
                        this.contractApprovals = response.items;
                    })
                    .catch(err => {
                        this.contractApprovals = [];
                    });
            },
            openNewRouteModal(){
                this.modals.route.data.approval_process_id = null;
                this.modals.route.data.property_id = null;
                this.modals.route.data.location = null;
                this.modals.route.data.effective_date = null;
                this.modals.route.open = true;
            },

            /*-- EDIT ------------------*/
            editRouteModal(item){
                this.modals.routeEdit.data = Object.assign({}, {
                    id: item.id,
                    contract_id: item.contract_id,
                    approval_process_id: item.approval_process_id,
                    location: item.location,
                    property_id: item.property_id,
                    effective_date: moment(item.effective_date).toDate()
                })
                this.modals.routeEdit.open = true;
            },
            editContractRoute(){
                if(!this.modals.routeEdit.data.effective_date){
                    return this.$alertNotification("Please select effective date", "danger");
                }

                //Save data
                if(this.modals.routeEdit.loading) return ;
                this.modals.routeEdit.loading = true;
                let request = Object.assign({}, this.modals.routeEdit.data);
                request.effective_date = moment(request.effective_date).format('YYYY-MM-DD');

                delete request.location;

                this.$store.dispatch("ApprovalTemplateController/updateItem", request)
                    .then(response => {
                        this.$alertNotification(this.$notificationV2('editing', 'approval_template'));
                        this.modals.routeEdit.loading = false;
                        this.modals.routeEdit.open = false;
                        this.getContractApproval();
                    })
                    .catch(err => {
                        this.modals.routeEdit.loading = false;
                        return this.$alertNotification("Can't editing this item!", "danger");
                    });
            },
        }
    }
</script>